/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { RT1GenerateRequest } from '../model/rT1GenerateRequest';
// @ts-ignore
import { RT1GenerateResponse } from '../model/rT1GenerateResponse';
// @ts-ignore
import { RT2SignRequest } from '../model/rT2SignRequest';
// @ts-ignore
import { RT2SignResponse } from '../model/rT2SignResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class EMescadSealControllerImplService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint get /api/seal/login
     * @param xSealAPIKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public login(xSealAPIKey: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public login(xSealAPIKey: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public login(xSealAPIKey: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public login(xSealAPIKey: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (xSealAPIKey === null || xSealAPIKey === undefined) {
            throw new Error('Required parameter xSealAPIKey was null or undefined when calling login.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xSealAPIKey !== undefined && xSealAPIKey !== null) {
            localVarHeaders = localVarHeaders.set('X-Seal-API-Key', String(xSealAPIKey));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/seal/login`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/seal/rt1-generate
     * @param xSealAPIKey 
     * @param xSealAPIAuthCode 
     * @param rT1GenerateRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public rt1Generate1(xSealAPIKey: string, xSealAPIAuthCode: string, rT1GenerateRequest: RT1GenerateRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<RT1GenerateResponse>;
    public rt1Generate1(xSealAPIKey: string, xSealAPIAuthCode: string, rT1GenerateRequest: RT1GenerateRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<RT1GenerateResponse>>;
    public rt1Generate1(xSealAPIKey: string, xSealAPIAuthCode: string, rT1GenerateRequest: RT1GenerateRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<RT1GenerateResponse>>;
    public rt1Generate1(xSealAPIKey: string, xSealAPIAuthCode: string, rT1GenerateRequest: RT1GenerateRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (xSealAPIKey === null || xSealAPIKey === undefined) {
            throw new Error('Required parameter xSealAPIKey was null or undefined when calling rt1Generate1.');
        }
        if (xSealAPIAuthCode === null || xSealAPIAuthCode === undefined) {
            throw new Error('Required parameter xSealAPIAuthCode was null or undefined when calling rt1Generate1.');
        }
        if (rT1GenerateRequest === null || rT1GenerateRequest === undefined) {
            throw new Error('Required parameter rT1GenerateRequest was null or undefined when calling rt1Generate1.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xSealAPIKey !== undefined && xSealAPIKey !== null) {
            localVarHeaders = localVarHeaders.set('X-Seal-API-Key', String(xSealAPIKey));
        }
        if (xSealAPIAuthCode !== undefined && xSealAPIAuthCode !== null) {
            localVarHeaders = localVarHeaders.set('X-Seal-API-Auth-Code', String(xSealAPIAuthCode));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/seal/rt1-generate`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RT1GenerateResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rT1GenerateRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/seal/rt2-sign
     * @param xSealAPIKey 
     * @param xSealAPIAuthCode 
     * @param rT2SignRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public rt2Sign1(xSealAPIKey: string, xSealAPIAuthCode: string, rT2SignRequest: RT2SignRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<RT2SignResponse>;
    public rt2Sign1(xSealAPIKey: string, xSealAPIAuthCode: string, rT2SignRequest: RT2SignRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<RT2SignResponse>>;
    public rt2Sign1(xSealAPIKey: string, xSealAPIAuthCode: string, rT2SignRequest: RT2SignRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<RT2SignResponse>>;
    public rt2Sign1(xSealAPIKey: string, xSealAPIAuthCode: string, rT2SignRequest: RT2SignRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (xSealAPIKey === null || xSealAPIKey === undefined) {
            throw new Error('Required parameter xSealAPIKey was null or undefined when calling rt2Sign1.');
        }
        if (xSealAPIAuthCode === null || xSealAPIAuthCode === undefined) {
            throw new Error('Required parameter xSealAPIAuthCode was null or undefined when calling rt2Sign1.');
        }
        if (rT2SignRequest === null || rT2SignRequest === undefined) {
            throw new Error('Required parameter rT2SignRequest was null or undefined when calling rt2Sign1.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xSealAPIKey !== undefined && xSealAPIKey !== null) {
            localVarHeaders = localVarHeaders.set('X-Seal-API-Key', String(xSealAPIKey));
        }
        if (xSealAPIAuthCode !== undefined && xSealAPIAuthCode !== null) {
            localVarHeaders = localVarHeaders.set('X-Seal-API-Auth-Code', String(xSealAPIAuthCode));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/seal/rt2-sign`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RT2SignResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rT2SignRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
